<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let x = 0;
	export let y = 0;
	export let visible = false;
	export let canPaste = false;

	const dispatch = createEventDispatcher<{
		addNode: void;
		paste: void;
		cancel: void;
	}>();

	function close() {
		dispatch('cancel');
		visible = false;
	}

	function onAddNode() {
		dispatch('addNode');
		visible = false;
	}

	function onPaste() {
		dispatch('paste');
		visible = false;
	}
</script>

{#if visible}
	<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
	<div class="fp-backdrop" on:click={close} role="presentation" />
	<div class="fp-menu" style="left:{x}px; top:{y}px;" role="menu" aria-label="Canvas actions">
		<button type="button" class="fp-item" role="menuitem" on:click={onAddNode}>
			<i class="fa fa-plus" />
			<span>Add node</span>
		</button>
		<button
			type="button"
			class="fp-item"
			class:disabled={!canPaste}
			disabled={!canPaste}
			role="menuitem"
			on:click={() => canPaste && onPaste()}
		>
			<i class="fa fa-paste" />
			<span>Paste</span>
		</button>
	</div>
{/if}

<style>
	.fp-backdrop {
		position: fixed;
		inset: 0;
		z-index: 11999;
		background: transparent;
	}

	.fp-menu {
		position: fixed;
		z-index: 12000;
		background: #2a2a2a;
		border: 1px solid #3a3a3a;
		border-radius: 8px;
		min-width: 180px;
		overflow: hidden;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
		padding: 4px 0;
	}

	.fp-item {
		display: flex;
		align-items: center;
		gap: 0.6rem;
		width: 100%;
		padding: 0.5rem 0.85rem;
		background: transparent;
		border: none;
		color: #e5e5e5;
		font-size: 0.85rem;
		cursor: pointer;
		text-align: left;
	}

	.fp-item:hover:not(:disabled) {
		background: #3a3a3a;
	}

	.fp-item.disabled,
	.fp-item:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	.fp-item i {
		width: 18px;
		text-align: center;
		font-size: 0.85rem;
		color: #9ca3af;
	}
</style>
